/*
 * @Author: linwl 1015547748@qq.com
 * @Date: 2025-10-14 15:46:25
 * @LastEditors: linwl 1015547748@qq.com
 * @LastEditTime: 2025-11-13 15:08:25
 * @FilePath: \mall\src\utils\setGlobalColor.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import colorConfig from '@/config/color.config'
import Vue from 'vue'

// 设置全局颜色
Vue.prototype.$GColor = colorConfig

// 设置全局css颜色
for (const [key, value] of Object.entries(colorConfig)) {
  document.documentElement.style.setProperty(
    `--${key}`,
    value
  )
}
